import React, { useState, useRef, useEffect } from "react";
import { Provider } from "react-redux";
import {
  ModalAcceptCancel,
  DateInput,
  TertiaryButton,
  ModalLayoutWrapper,
  FormCreateNewClient,
  ConfirmModalV2,
  SelectInput,
  Icon,
  // @ts-ignore
} from "@viuti/recursos";
import { AddIcon, TimesIcon, FillPlayIcon } from "@Models/icons";
import { SelectClientSearch } from "./components/SelectClientSearch";
import ClientAlertModal from "../ClientAlertModal/ClientAlertModal";
import { NoCustomer } from "./components/Custommer/NoCustommer";
import { Customer } from "./components/Custommer/Customer";
import { AppointmentDetail } from "./components/AppointmentDetail/AppointmentDetail";
import styles from "./FormReservation.module.css";
import { postNewReserve_adapter } from "@Adapters/reserve/postNewReserve.adapter";
import { deleteDeleteAppointment_adapter } from "@Adapters/reserve/deleteDeleteAppointment.adapter";
import { useAdaptReserveDetail } from "./hooks/useAdaptReserveDetail";
import { getServices_adapter, Service } from "@Adapters/getServices.adapter";
import { STATUS, STATUS_OPTIONS } from "./data/status";
import { putUpdateReserveDetail_adapter } from "@Adapters/reserve/putUpdateReserveDetail.adapter";
import { putConvertReserveToCommand_adapter } from "@Adapters/reserve/putConvertReserveToCommand.adapter";
import { AppointmentRow } from "./components/AppointmentDetail/interfaces/appointmentRow";
import { store as employeesStore } from "@/modules/employees/redux/index";
import SchedulesModal from "@/modules/employees/components/ui/molecules/SchedulesModal/SchedulesModal";
import ChecklistModal from "@/modules/commissions/components/ChecklistModal/ChecklistModal";
import { getEmployeeSchedulesAdapter } from "@/modules/employees/adapters/getSchedules/getSchedules.adapter";
import { addEmployeeServicesService } from "@/modules/employees/services/posts";
import { deleteEmployeeServicesService } from "@/modules/employees/services/puts";
import { getEmployeeServicesService } from "@/modules/employees/services/gets";
import { getAvailableHours_adapter } from "@Adapters/employee/getAvailableHours.adapter";
import { getEmployees_adapter } from "@Adapters/employee/getEmployees.adapter";
import ReservationHistory from "@/modules/reservations/components/ui/ReservationHistory/ReservationHistory";
import WhatsappMessageHistory from "../WhatsappMessageHistory/WhatsappMessageHistory";

const generateId = () => "_" + Math.random().toString(36).substr(2, 9);

const currentDate = new Date().toISOString().split("T")[0];

interface FormReservationProps {
  initialDate?: string;
  /** Hora "HH:MM" preseleccionada al crear desde un cuadrante del calendario. */
  initialHour?: string;
  /** Nombre del empleado de la columna (vista diaria) a preseleccionar. */
  initialEmployeeName?: string;
  setToasterResponse: (state: { message: string; status: number }) => void;
  reserveId?: string;
  callBacks?: {
    onClose?: () => void;
    onEditOrCreateSuccess?: (data: any) => void;
    onStatusSuccess?: (data: any) => void;
    onDeleteSuccess?: (data: any) => void;
  };
  initialCustomer?: InitialCustomer;
  initialServices?: Service[];
  /** ID del detalle clickeado en la agenda para resaltarlo en el modal. */
  highlightDetailId?: number;
}

const getAvailableStatuses = (currentStatus: number): number[] => {
  switch (currentStatus) {
    case STATUS.PENDING:
      return [STATUS.CONFIRMED, STATUS.CANCELLED];
    case STATUS.CONFIRMED:
      return [STATUS.NO_SHOW, STATUS.CANCELLED, STATUS.EN_COMANDA];
    case STATUS.RESCHEDULED:
      return [STATUS.CONFIRMED, STATUS.CANCELLED];
    case STATUS.CANCELLED_LEGACY:
    case STATUS.CANCELLED:
      return [];
    case STATUS.EXECUTED:
      return [STATUS.ATTENDED];
    case STATUS.EN_COMANDA:
      return [STATUS.ATTENDED];
    case STATUS.ATTENDED:
      return [];
    case STATUS.DELAYED:
      return [STATUS.CONFIRMED, STATUS.CANCELLED];
    default:
      return [STATUS.CANCELLED];
  }
};
interface InitialCustomer {
  name: string;
  surname: string;
  birthDate: string;
  typeDocumentId: number;
  document: string;
  category: string;
  email: string;
  phone: string;
  id: number;
}

const FormReservation: React.FC<FormReservationProps> = ({
  initialDate = currentDate,
  initialHour = undefined,
  initialEmployeeName = undefined,
  setToasterResponse = () => {},
  reserveId = null,
  callBacks = {},
  initialCustomer = null,
  initialServices = [],
  highlightDetailId = undefined,
}) => {
  const { onClose, onEditOrCreateSuccess, onStatusSuccess, onDeleteSuccess } =
    callBacks;
  const inputRef = useRef(null);
  const [dateReservation, setDateReservation] = useState<string>(initialDate);
  const [initialDateReservation, setInitialDateReservation] =
    useState<string>(initialDate);
  const [customerSelected, setCustomerSelected] =
    useState<any>(initialCustomer);
  const [initialSelectCustomer, setInitialSelectCustomer] = useState<any>(null);
  const [isOpenModalNewClient, setIsOpenModalNewClient] =
    useState<boolean>(false);
  const [showClientAlert, setShowClientAlert] = useState(false);

  useEffect(() => {
    if (customerSelected?.id && (customerSelected.conflictNotes || customerSelected.notes)) {
      setShowClientAlert(true);
    }
  }, [customerSelected?.id]);
  const [services, setServices] = useState<Service[]>(initialServices);
  const [initialStatusReserve, setInitialStatusReserve] =
    useState<number>(null);
  const [statusReserve, setStatusReserve] = useState<number>(null);
  const [selectedItems, setSelectedItems] = useState<AppointmentRow[]>([]);

  const [initialSelectItems, setInitialSelectItems] = useState([]);
  const [initialComments, setInitialComments] = useState("");

  const [aditionalComments, setAditionalComments] = useState("");
  const [errorMessage, setErrorMessage] = useState({
    date: "",
  });
  const [loadingCreateReservation, setLoadingCreateReservation] =
    useState<boolean>(false);
  const [loadingCancelReservation, setLoadingDeleteReservation] =
    useState<boolean>(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [availableHours, setAvailableHours] = useState({});
  const [loadingServices, setLoadingServices] = useState(false);
  const [messageConflicting, setMessageConflicting] = useState("");
  const [empleadosOcupados, setEmpleadosOcupados] = useState([]);
  const [idConflictingItem, setIdConflictingItem] = useState([]);
  const [incompleteItems, setIncompleteItems] = useState([]);
  const [editCustomer, setEditCustomer] = useState(false);
  const [loadingHours, setLoadingHours] = useState(false);
  const [loadingHoursId, setLoadingHoursId] = useState(null);
  const isEdit = Boolean(reserveId);

  // Employee modals state
  const [schedulesModalVisible, setSchedulesModalVisible] = useState(false);
  const [servicesModalVisible, setServicesModalVisible] = useState(false);
  const [selectedEmployeeForModal, setSelectedEmployeeForModal] = useState<number | null>(null);
  const [employeeSchedules, setEmployeeSchedules] = useState([]);
  const [allEmployeesForModal, setAllEmployeesForModal] = useState([]);
  const [serviceIdForContext, setServiceIdForContext] = useState<number | null>(null);

  const isDisabled =
    loadingCreateReservation ||
    isLoadingDetail ||
    initialStatusReserve === STATUS.CANCELLED ||
    initialStatusReserve === STATUS.ATTENDED ||
    initialStatusReserve === STATUS.EN_COMANDA;
  const isDisabledButton =
    initialStatusReserve === STATUS.CANCELLED ||
    initialStatusReserve === STATUS.ATTENDED ||
    initialStatusReserve === STATUS.EN_COMANDA;

  const isDisabledNoShow = initialStatusReserve === STATUS.NO_SHOW;

  const [isVisibleDeleteModal, setIsVisibleDeleteModal] =
    useState<boolean>(false);

  const [loadingComanda, setLoadingComanda] = useState(false);

  useEffect(() => {
    // solo si no estamos en modo edición (creando una nueva reserva)
    // y si customerSelected acaba de ser establecido
    if (!isEdit && customerSelected && selectedItems.length === 0) {
      setSelectedItems([
        {
          id: generateId(),
          service: null,
          employee: "",
          schedule: "",
          serviceSearch: "",
        },
      ]);
    }
    // Si el cliente se deselecciona en un nuevo formulario de reserva, limpiamos los items
    if (!isEdit && customerSelected === null && selectedItems.length > 0) {
      setSelectedItems([]);
    }
  }, [
    customerSelected,
    isEdit,
    selectedItems.length,
    generateId,
    setSelectedItems,
  ]);

  useAdaptReserveDetail(
    reserveId,
    setToasterResponse,
    setCustomerSelected,
    setSelectedItems,
    setIsLoadingDetail,
    setInitialSelectItems,
    generateId,
    setStatusReserve,
    setInitialStatusReserve,
    setInitialSelectCustomer,
    setAvailableHours,
    setLoadingHours,
    setLoadingHoursId,
    setDateReservation,
    setAditionalComments,
    setInitialComments,
    setInitialDateReservation
  );

  const hayCambios = () => {
    const hayCambiosEnItems =
      JSON.stringify(initialSelectItems) !== JSON.stringify(selectedItems);
    const hayCambiosEnCliente =
      JSON.stringify(initialSelectCustomer) !==
      JSON.stringify(customerSelected);
    const hayCambiosEnEstado = statusReserve !== initialStatusReserve;
    const hayCambiosEnComentarios = initialComments !== aditionalComments;
    const hayCambiosEnFecha = dateReservation !== initialDateReservation;

    return (
      hayCambiosEnItems ||
      hayCambiosEnCliente ||
      hayCambiosEnEstado ||
      hayCambiosEnComentarios ||
      hayCambiosEnFecha
    );
  };

  const openModalNewClient = () => {
    setIsOpenModalNewClient(true);
  };

  const handleButtonClickFocusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const postNewClient = (clientResponse) => {
    const res = clientResponse;
    setCustomerSelected({
      name: res?.name,
      surname: res?.lastName,
      birthDate: res?.dateOfBirth,
      documentTypeId: res?.documentType || 2,
      document: res?.documentNumber,
      category: res?.category?.categoryName || "Sin especificar",
      email: res?.mail || "Sin especificar",
      phone: res?.phone || "Sin especificar",
      id: res?.userId,
    });
  };

  const handleDateChange = async (e) => {
    const selectedDate = e.target.value;
    setDateReservation(selectedDate);

    if (selectedDate < currentDate) {
      setErrorMessage({ date: "No se puede colocar fechas pasadas." });
    } else {
      setErrorMessage({ date: "" });
    }

    if (!isEdit) return;

    // Reagendar a otra fecha: conservamos los servicios y empleados ya
    // cargados. La disponibilidad horaria depende del día de la semana, así
    // que limpiamos la hora elegida y recargamos los horarios disponibles del
    // empleado para la nueva fecha (antes se borraba todo el detalle).
    const itemsToReload = selectedItems.filter(
      (item) => item.service && item.employee
    );
    if (itemsToReload.length === 0) return;

    setSelectedItems((prevItems) =>
      prevItems.map((item) =>
        item.service && item.employee ? { ...item, schedule: "" } : item
      )
    );

    setLoadingHours(true);
    const newAvailableHours = {};
    for (const item of itemsToReload) {
      setLoadingHoursId(item.id);
      const hoursResponse = await getAvailableHours_adapter({
        date: selectedDate,
        employeeId: item.employee,
        priceServiceId: item.service,
        reserveId: isEdit ? reserveId : null,
      });
      newAvailableHours[item.id] = hoursResponse.isSuccess
        ? hoursResponse.data
        : [];
    }
    setLoadingHoursId(null);
    setAvailableHours(newAvailableHours);
    setLoadingHours(false);
  };

  const deselectCustomer = () => {
    setCustomerSelected(null);
  };

  const isFormComplete = () => {
    const isCustomerSelected = customerSelected !== null;
    const isDateSelected = dateReservation !== "";
    // El estilista puede quedar "Por asignar" (employee ""): no se exige.
    const areItemsComplete = selectedItems.every(
      (item) => item.service && item.schedule
    );

    const noHayErrores =
      messageConflicting === "" &&
      empleadosOcupados.length === 0 &&
      incompleteItems.length === 0 &&
      idConflictingItem.length === 0;

    return (
      isCustomerSelected && isDateSelected && areItemsComplete && noHayErrores
    );
  };

  const orderHours = () => {
    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      try {
        return updatedItems.sort((a, b) => {
          const timeA = a.schedule.split(":").map(Number);
          const timeB = b.schedule.split(":").map(Number);
          return timeA[0] - timeB[0] || timeA[1] - timeB[1];
        });
      } catch (error) {
        return updatedItems;
      }
    });
  };

  const createOrEditReservation = async (data) => {
    if (isEdit) {
      const deletedDetails = initialSelectItems
        .filter(
          (initialItem) =>
            !selectedItems.some(
              (selectedItem) => selectedItem.id === initialItem.id
            )
        )
        .map((item) => item.id);

      const newDetails = selectedItems.filter(
        (selectedItem) =>
          !initialSelectItems.some(
            (initialItem) => initialItem.id === selectedItem.id
          )
      );

      const isDateChanged = dateReservation !== initialDateReservation;

      const editedDetails = selectedItems.filter((selectedItem) => {
        const initialItem = initialSelectItems.find(
          (item) => item.id === selectedItem.id
        );
        if (!initialItem) return false;
        // Al cambiar el día viajan todos los servicios, aunque no se les haya
        // tocado nada más: si no, la cita se mueve de fecha en la cabecera y los
        // servicios se quedan en el día anterior.
        if (isDateChanged) return true;
        return (
          initialItem.service !== selectedItem.service ||
          initialItem.employee !== selectedItem.employee ||
          initialItem.schedule !== selectedItem.schedule ||
          initialItem.duration !== selectedItem.duration ||
          initialItem.isFija !== selectedItem.isFija
        );
      });

      const isStatusChanged = initialStatusReserve !== statusReserve;
      const hoursSelectedItems = selectedItems
        .map((item) => item.schedule)
        .filter((schedule) => schedule !== "");

      const hoursSelectedInitialItems = initialSelectItems
        .map((item) => item.schedule)
        .filter((schedule) => schedule !== "");

      const isHourChanged =
        hoursSelectedItems.length !== hoursSelectedInitialItems.length ||
        hoursSelectedItems.some(
          (hour, index) => hour !== hoursSelectedInitialItems[index]
        );

      const adaptStatus =
        isStatusChanged || (!isHourChanged && !isDateChanged) ? statusReserve : STATUS.RESCHEDULED;

      const adaptRequest = {
        reserveId: Number(reserveId),
        newStatus: adaptStatus,
        deleteReserveDetailsIds: deletedDetails,
        newReserveDetails: newDetails,
        editReserveDetails: editedDetails,
        observation: aditionalComments,
        dateAttention: dateReservation,
      };

      const response = await putUpdateReserveDetail_adapter(adaptRequest);
      if (response.isSuccess) {
        onEditOrCreateSuccess && onEditOrCreateSuccess(data);
        setInitialStatusReserve(statusReserve);
        setToasterResponse({
          message: "Reserva actualizada correctamente.",
          status: response.status,
        });
        setLoadingCreateReservation(false);
        setIsLoadingDetail(false);
        setInitialSelectItems(data.details);
        setStatusReserve(adaptStatus);
        setInitialStatusReserve(adaptStatus);
        setInitialComments(aditionalComments);
      } else {
        setLoadingCreateReservation(false);
        setIsLoadingDetail(false);
        setToasterResponse({
          message: response.message,
          status: response.status,
        });
      }
    } else {
      const response = await postNewReserve_adapter(data);
      if (response.isSuccess) {
        onEditOrCreateSuccess && onEditOrCreateSuccess(data);
        setToasterResponse({
          message: "Reserva creada correctamente.",
          status: response.status,
        });
        onClose && onClose();
      } else {
        setToasterResponse({
          message: response.message,
          status: response.status,
        });
        setLoadingCreateReservation(false);
      }
    }
  };

  const nextClick = async () => {
    const orderItems = [...selectedItems];
    setLoadingCreateReservation(true);

    const isSorted = (items) => {
      for (let i = 1; i < items.length; i++) {
        const timeA = items[i - 1].schedule.split(":").map(Number);
        const timeB = items[i].schedule.split(":").map(Number);
        if (
          timeA[0] > timeB[0] ||
          (timeA[0] === timeB[0] && timeA[1] > timeB[1])
        ) {
          return false; // Si encontramos un par desordenado, retornamos false
        }
      }
      return true; // Si no encontramos desorden, retornamos true
    };

    // Verificamos si las horas están ordenadas
    if (!isSorted(orderItems)) {
      orderHours();
      try {
        orderItems.sort((a, b) => {
          const timeA = a.schedule.split(":").map(Number);
          const timeB = b.schedule.split(":").map(Number);
          return timeA[0] - timeB[0] || timeA[1] - timeB[1];
        });
      } catch (error) {
        return orderItems;
      }
      setTimeout(async () => {
        const data = {
          clientId: customerSelected.id,
          observation: aditionalComments,
          prepaid: 0,
          dateAttention: dateReservation,
          details: orderItems,
        };
        await createOrEditReservation(data); // Llamamos a la función para crear la reserva
      }, 1000);
    } else {
      const data = {
        clientId: customerSelected.id,
        observation: aditionalComments,
        prepaid: 0,
        dateAttention: dateReservation,
        details: orderItems,
      };
      await createOrEditReservation(data); // Llamamos a la función para crear la reserva
    }
  };

  const confirmDeleteReservation = async () => {
    setLoadingDeleteReservation(true);
    const response = await deleteDeleteAppointment_adapter(Number(reserveId));
    if (!response.isSuccess) {
      setLoadingDeleteReservation(false);
      setToasterResponse({
        message: response.message,
        status: response.status,
      });
      return;
    }
    setToasterResponse({
      message: "Reserva eliminada correctamente.",
      status: response.status,
    });
    onDeleteSuccess && onDeleteSuccess(dateReservation);
    setTimeout(() => {
      onClose && onClose();
    }, 1000);
    setLoadingDeleteReservation(false);
    setIsVisibleDeleteModal(false);
  };

  const handleCancelEditCustomer = () => {
    setEditCustomer(false);
    setCustomerSelected(initialSelectCustomer);
  };

  useEffect(() => {
    const getServices = async () => {
      if (services.length) return;
      setLoadingServices(true);
      if (services.length > 0) {
        setLoadingServices(false);
        return;
      } else {
        const response = await getServices_adapter();
        if (response.isSuccess) {
          setServices(response.data);
        } else {
          setToasterResponse({
            message: "Hubo un error al traer los servicios",
            status: 400,
          });
        }
      }
      setLoadingServices(false);
    };
    getServices();
  }, [customerSelected]);

  const refreshAvailableHoursForEmployee = async (employeeId: number) => {
    const affectedItems = selectedItems.filter(
      (item) => item.employee === employeeId && item.service
    );
    for (const item of affectedItems) {
      const hoursResponse = await getAvailableHours_adapter({
        date: dateReservation,
        employeeId: employeeId,
        priceServiceId: item.service,
        reserveId: isEdit ? reserveId : null,
      });
      if (hoursResponse.isSuccess) {
        setAvailableHours((prev) => ({ ...prev, [item.id]: hoursResponse.data }));
      }
    }
  };

  const handleSchedulesSaveSuccess = async () => {
    setSchedulesModalVisible(false);
    setToasterResponse({
      message: "Horarios actualizados correctamente",
      status: 200,
    });
    if (selectedEmployeeForModal) {
      await refreshAvailableHoursForEmployee(selectedEmployeeForModal);
    }
  };

  const handleOpenSchedulesModal = async (employeeId: number) => {
    const response = await getEmployeeSchedulesAdapter(employeeId);
    if (response.isSuccess) {
      setEmployeeSchedules(response.data);
      setSelectedEmployeeForModal(employeeId);
      setSchedulesModalVisible(true);
    } else {
      setToasterResponse({
        message: "Error al cargar los horarios del empleado",
        status: 400,
      });
    }
  };

  const handleOpenServicesModal = async (_employeeId: number, serviceId: number) => {
    let currentServices = services;
    let selectedService = currentServices.find((s) => s.idPrice === serviceId);

    // Si no tiene idService, refrescar la lista de servicios
    if (selectedService && selectedService.idService == null) {
      const refreshed = await getServices_adapter();
      if (refreshed.isSuccess) {
        setServices(refreshed.data);
        currentServices = refreshed.data;
        selectedService = currentServices.find((s) => s.idPrice === serviceId);
      }
    }

    if (!selectedService || selectedService.idService == null) return;

    const empRes = await getEmployees_adapter();
    if (empRes.isSuccess) {
      setAllEmployeesForModal(empRes.data);
      setServiceIdForContext(selectedService.idService);
      setServicesModalVisible(true);
    } else {
      setToasterResponse({
        message: "Error al cargar los empleados",
        status: 400,
      });
    }
  };

  const handleSaveServiceEmployees = async (selectedEmployeeIds: number[]) => {
    if (!serviceIdForContext) return;
    // Empleados actualmente asignados al servicio
    const currentService = services.find((s) => s.idService === serviceIdForContext);
    const currentEmployeeIds = currentService?.employees.map((e) => e.idEmployee) || [];

    const employeesToAdd = selectedEmployeeIds.filter((id) => !currentEmployeeIds.includes(id));
    const employeesToRemove = currentEmployeeIds.filter((id) => !selectedEmployeeIds.includes(id));

    // Agregar empleados
    const addPromises = employeesToAdd.map((empId) =>
      addEmployeeServicesService({ idService: serviceIdForContext, idEmployee: empId })
    );

    // Para quitar, necesito el idServicesEmployee (ID de la relación)
    const removePromises = employeesToRemove.map(async (empId) => {
      const empServices = await getEmployeeServicesService(empId);
      if (!empServices.isSuccess) return empServices;
      const relation = empServices.data.find((s: any) => s.idService === serviceIdForContext);
      if (!relation) return { success: false, message: "Relación no encontrada" };
      return deleteEmployeeServicesService({ id: relation.idServicesEmployee, idEmployee: empId });
    });

    const results = await Promise.all([...addPromises, ...removePromises]);
    const allSuccess = results.every((r: any) => r.isSuccess || r.success);

    if (allSuccess) {
      const refreshed = await getServices_adapter();
      if (refreshed.isSuccess) {
        setServices(refreshed.data);
        // Limpiar filas donde un empleado fue removido del servicio
        if (employeesToRemove.length > 0) {
          setSelectedItems((prev) =>
            prev.map((item) => {
              if (!item.service || !item.employee) return item;
              const updatedService = refreshed.data.find((s) => s.idPrice === item.service);
              const stillAssigned = updatedService?.employees.some(
                (e) => e.idEmployee === item.employee
              );
              if (!stillAssigned) {
                return { ...item, employee: "", schedule: "" };
              }
              return item;
            })
          );
        }
      }
      setToasterResponse({
        message: "Empleados del servicio actualizados correctamente",
        status: 200,
      });
      setServicesModalVisible(false);
    } else {
      setToasterResponse({
        message: "Error al actualizar algunos empleados",
        status: 400,
      });
    }
  };

  const title = () => {
    if (isEdit) {
      const statusName = STATUS_OPTIONS.find((s) => s.id === initialStatusReserve)?.name.toLowerCase() || "";
      return `Reserva${statusName ? ` ${statusName}` : ""}`;
    }
    return "Nueva reserva";
  };

  const statusOptions = STATUS_OPTIONS.filter((status) =>
    [
      initialStatusReserve,
      ...getAvailableStatuses(initialStatusReserve),
    ].includes(status.id)
  ).map((status) => ({
    value: status.id,
    name: status.name,
  }));

  const handleStatusChange = (e) => {
    setStatusReserve(Number(e.target.value));
  };

  const handleConvertToComanda = async () => {
    setLoadingComanda(true);
    setIsLoadingDetail(true);
    try {
      const response = await putConvertReserveToCommand_adapter(
        Number(reserveId)
      );
      if (response.isSuccess) {
        setStatusReserve(STATUS.EN_COMANDA);
        setInitialStatusReserve(STATUS.EN_COMANDA);
        onStatusSuccess && onStatusSuccess(STATUS.EN_COMANDA);
        setToasterResponse({
          message: "Se ha convertido la reserva a comanda correctamente.",
          status: response.status,
        });
      } else {
        setToasterResponse({
          message: response.message,
          status: response.status,
        });
      }
    } catch (error) {
      setIsLoadingDetail(false);
      setToasterResponse({
        message: "Error al convertir a comanda",
        status: 400,
      });
    } finally {
      setLoadingComanda(false);
      setIsLoadingDetail(false);
    }
  };

  // Añadir mensaje para estado EN_COMANDA
  const getStatusMessage = () => {
    if (initialStatusReserve === STATUS.EN_COMANDA) {
      return "Esta reserva ha sido convertida en comanda y no puede ser modificada";
    }
    return "";
  };

  return (
    <>
    <ModalAcceptCancel
      title={title()}
      showButtons={{
        showButtonOne: initialStatusReserve && initialStatusReserve !== STATUS.EN_COMANDA,
        // Deshabilitar botón guardar si está en comanda
        showButtonTwo:
          !isDisabledButton && initialStatusReserve !== STATUS.EN_COMANDA,
        showButtonClose: true,
      }}
      buttonTwo={{
        textButtonTwo: "Guardar",
        actionButtonTwo: nextClick,
        isDisabled:
          !hayCambios() || loadingCreateReservation || !isFormComplete(),
        isLoading: loadingCreateReservation,
        buttonProps: { "data-testid": "btn-save-reservation" },
      }}
      buttonOne={{
        textButtonOne: "Eliminar reserva",
        actionButtonOne: () => {
          setIsVisibleDeleteModal(true);
        },
        isDisabled: loadingCancelReservation || isLoadingDetail,
        isLoading: loadingCancelReservation,
      }}
      actionButtonClose={onClose}
    >
      <div className={styles.formContainer}>
        <section className={styles.dateContainer}>
          <div className={styles.dateInputContainer} data-testid="reservation-date">
            <DateInput
              required={true}
              inputProps={{
                value: dateReservation,
                onChange: handleDateChange,
                min: currentDate,
              }}
              error={errorMessage.date}
              touched={errorMessage.date}
              disabled={isLoadingDetail || isDisabled}
            />
          </div>
          {isEdit && editCustomer && customerSelected === null && (
            <TertiaryButton
              buttonProps={{
                onClick: handleCancelEditCustomer,
                disabled: false,
              }}
              icon={TimesIcon}
              value="Cancelar"
            />
          )}
          {customerSelected === null && (
            <>
              {!isLoadingDetail && (
                <div data-testid="reservation-client">
                  <TertiaryButton
                    buttonProps={{
                      onClick: openModalNewClient,
                      disabled: false,
                    }}
                    icon={AddIcon}
                    value="Nuevo cliente"
                  />
                  <SelectClientSearch
                    setStateResponse={setToasterResponse}
                    setCustomerSelected={setCustomerSelected}
                    setInitialSelectCustomer={setInitialSelectCustomer}
                    inputRef={inputRef}
                  />
                </div>
              )}
            </>
          )}

          {customerSelected === null ? (
            <NoCustomer
              isLoading={isLoadingDetail}
              handleButtonClickFocusInput={handleButtonClickFocusInput}
            />
          ) : (
            <>
              <Customer
                {...customerSelected}
                deselectCustomer={deselectCustomer}
                isEdit={isEdit}
                setCustomerSelected={setCustomerSelected}
                setEditCustomer={setEditCustomer}
              />
              {isEdit && customerSelected && (
                <div className={styles.statusSection}>
                  <SelectInput
                    label="Estado de la reserva"
                    name="status"
                    value={statusReserve}
                    touched={false}
                    error={false}
                    handleChange={handleStatusChange}
                    handleBlur={() => {}}
                    items={statusOptions}
                    required={true}
                    placeholder="Seleccione un estado"
                    width="100%"
                    disabled={
                      isLoadingDetail ||
                      initialStatusReserve === STATUS.CANCELLED ||
                      initialStatusReserve === STATUS.ATTENDED ||
                      initialStatusReserve === STATUS.EN_COMANDA ||
                      loadingComanda ||
                      loadingCreateReservation
                    }
                  />
                  {initialStatusReserve === STATUS.EN_COMANDA ||
                  initialStatusReserve === STATUS.ATTENDED
                    ? null
                    : statusReserve !== STATUS.CANCELLED &&
                      statusReserve !== STATUS.NO_SHOW && (
                        <button
                          onClick={handleConvertToComanda}
                          disabled={isLoadingDetail || loadingComanda}
                          className={styles.comandaButton}
                        >
                          {loadingComanda ? (
                            <span className={styles.loader}></span>
                          ) : (
                            <>
                              <Icon
                                path={FillPlayIcon}
                                size={18}
                                color="#45348e"
                              />
                              Convertir a comanda
                            </>
                          )}
                        </button>
                      )}
                </div>
              )}
              {isEdit && reserveId && (
                <ReservationHistory reserveId={reserveId} />
              )}
              {isEdit && reserveId && (
                <WhatsappMessageHistory reservationId={Number(reserveId)} />
              )}
            </>
          )}
        </section>
        <section>
          <AppointmentDetail
            date={dateReservation}
            selectedItems={selectedItems}
            generateId={generateId}
            services={services}
            setSelectedItems={setSelectedItems}
            setStateResponse={setToasterResponse}
            additionalComments={aditionalComments}
            setAdditionalComments={setAditionalComments}
            isEdit={isEdit}
            availableHours={availableHours}
            setAvailableHours={setAvailableHours}
            loadingServices={loadingServices}
            setMessageConflicting={setMessageConflicting}
            messageConflicting={messageConflicting}
            empleadosOcupados={empleadosOcupados}
            setEmpleadosOcupados={setEmpleadosOcupados}
            idConflictingItem={idConflictingItem}
            setIdConflictingItem={setIdConflictingItem}
            incompleteItems={incompleteItems}
            setIncompleteItems={setIncompleteItems}
            orderHours={orderHours}
            reserveId={reserveId}
            isDisabled={isDisabled}
            isDisabledNoShow={isDisabledNoShow}
            loadingHours={loadingHours}
            setLoadingHours={setLoadingHours}
            loadingHoursId={loadingHoursId}
            setLoadingHoursId={setLoadingHoursId}
            getStatusMessage={getStatusMessage}
            customerSelected={customerSelected}
            onOpenSchedulesModal={handleOpenSchedulesModal}
            onOpenServicesModal={handleOpenServicesModal}
            preferredHour={isEdit ? undefined : initialHour}
            preferredEmployeeName={isEdit ? undefined : initialEmployeeName}
            highlightDetailId={highlightDetailId}
          />
        </section>
        {!isFormComplete() && !loadingCreateReservation && (
          <p style={{
            textAlign: 'center',
            font: '600 0.7rem "Mulish", sans-serif',
            color: '#d4790a',
            background: '#fff8ed',
            border: '1px solid #fde6c0',
            borderRadius: '6px',
            padding: '6px 10px',
            margin: '8px 0 0',
          }}>
            {!customerSelected
              ? "Falta: seleccionar un cliente"
              : selectedItems.every(i => !i.service)
              ? "Falta: seleccionar al menos un servicio"
              : selectedItems.some(i => i.service && !i.schedule)
              ? "Falta: elegir hora para cada servicio"
              : "Completa todos los campos para guardar"}
          </p>
        )}
      </div>
      {isOpenModalNewClient && (
        <ModalLayoutWrapper>
          <FormCreateNewClient
            isDisabled={isOpenModalNewClient}
            setIsDisabled={setIsOpenModalNewClient}
            nextClick={(client) => postNewClient(client)}
          />
        </ModalLayoutWrapper>
      )}
      <ConfirmModalV2
        title={"Eliminar reserva"}
        message={
          <p className={styles.remove__client__modal__message}>
            ¿Estás seguro que deseas eliminar la reserva? Esta acción no podrá
            deshacerse.
          </p>
        }
        buttonLbl={"Eliminar"}
        controller={{
          visible: isVisibleDeleteModal,
          setVisible: setIsVisibleDeleteModal,
          isLoading: loadingCancelReservation,
          isDisabled: loadingCancelReservation,
        }}
        confirmAction={confirmDeleteReservation}
      />
      {schedulesModalVisible && selectedEmployeeForModal && (
        <Provider store={employeesStore}>
          <SchedulesModal
            initialSchedulesState={employeeSchedules}
            setInitialSchedulesState={setEmployeeSchedules}
            visible={schedulesModalVisible}
            setVisible={setSchedulesModalVisible}
            idEmployee={selectedEmployeeForModal}
            onSaveSuccess={handleSchedulesSaveSuccess}
          />
        </Provider>
      )}
      {servicesModalVisible && serviceIdForContext != null && (
        <ChecklistModal
          title="Asignar empleados al servicio"
          items={allEmployeesForModal.map((e: any) => ({
            id: e.idEmployee,
            label: `${e.name} ${e.lastName}`,
          }))}
          selectedIds={
            services
              .find((s) => s.idService === serviceIdForContext)
              ?.employees.map((e) => e.idEmployee) || []
          }
          onConfirm={handleSaveServiceEmployees}
          onClose={() => setServicesModalVisible(false)}
        />
      )}
    </ModalAcceptCancel>
    {showClientAlert && customerSelected && (
      <ClientAlertModal
        clientName={`${customerSelected.name || ""} ${customerSelected.surname || ""}`.trim()}
        notes={customerSelected.notes}
        conflictNotes={customerSelected.conflictNotes}
        onClose={() => setShowClientAlert(false)}
      />
    )}
    </>
  );
};

export default FormReservation;
